class MainProductSelector extends ProductSelector {
  constructor() {
    super();

    this.colorOptions = this.querySelector('[data-color-options]');
  }

  onVariantChange(event) {
    if (event.target.type === 'number') return;
    super.updateOptions();
    super.updateVariant();
    super.toggleAddButton(false, '');
    super.handleErrorMessage();
    super.filterOptions();

    if (!this.currentVariant) {
      super.toggleAddButton(true, '');
      super.setUnavailable();

      return;
    }

    if (!this.currentVariant.available) {
      ``;
      super.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateMedia();
    this.updateURL();
    super.updateVariantInput();
    this.renderProductInfo();
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const productMedia = document.querySelector('product-media');
    productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }

  renderProductInfo() {
    const destinationPrice = document.querySelector(
      `#price-${this.dataset.sectionId}`,
    );

    const selectedValueContainer = this.colorOptions.querySelector(
      '[data-selected-value]',
    );

    if (this.colorOptions && selectedValueContainer) {
      const colorOptionPosition = this.colorOptions.dataset.optionPosition;

      selectedValueContainer.textContent =
        this.currentVariant.options[colorOptionPosition - 1];
    }

    if (destinationPrice && this.currentVariantPrice?.price_html) {
      destinationPrice.classList.remove('visually-hidden');
      destinationPrice.innerHTML = this.currentVariantPrice.price_html;
    }
  }
}

customElements.define('main-product-selector', MainProductSelector);
